/* eslint-disable no-console */
import { Backdrop, CircularProgress, Link } from '@mui/material';
import Grid from '@mui/material/Grid';
import { DataGridPro, GridValueFormatterParams } from '@mui/x-data-grid-pro';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setUserDocPermissions } from 'src/store/User';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import DeleteDocument from './DeleteDocument';
import './DocumentViewer.scss';
import { DocumentRespType, DocumentViewerDetails } from './types';
import { CustomPagination } from 'src/util/DataTableFooter';
import { CustomToolbar } from 'src/components/modelviewer/CustomToolBar';
import { useGetStudiesQuery } from 'src/components/Services/Utils';

const RecentDocuments: React.FunctionComponent<any> = props => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const documentKey: any = useAppSelector(state => state.preferences.documentKey);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);
  const [result, setResult] = React.useState<any>([]);
  const [documentData, setDocumentData] = useState<any>([]);
  const [openVersion, setOpenVersion] = useState(false);
  const [editedFmID, setEditedFmID] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dataGridComponent, setDataGridComponent] = useState(true);
  const [deleteDocumentCheck, setDeleteDocumentCheck] = useState(false);
  const [documentToDisplay, setDocumentToDisplay] = useState<DocumentViewerDetails>();
  const [updatedPropsForDoc, setUpdatedPropsForDoc] = useState<any>();
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [rowCount, setRowCount] = useState<number>(0);
  const dispatch = useDispatch();
  const docService = new DocManagementService();
  const { checkPermission } = usePermissionWrapper();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  /**
   * Bharath
   */
  const gridFunc = async (documentDetails: DocumentViewerDetails) => {
    try {
      const response: any = await docService.getDocAccessPermissions(documentDetails);
      if (response.data != null && response.data.length > 0) {
        const docAccessPermissions: any = response.data.map((item: any) => item.permission);
        dispatch(setUserDocPermissions(docAccessPermissions));
        setDocumentToDisplay(documentDetails);
        setDocumentDetail(dispatch, [documentDetails]);
        setDataGridComponent(false);
      } else {
        updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
      }
    } catch (e: any) {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
  };
  /**
   * Bharath end
   */
  const columns = [
    {
      field: 'tmf_document_name',
      headerName: 'Document Name',
      renderCell: (params: any) =>
        checkPermission('view_document_details') ? (
          <Link onClick={() => gridFunc(params.row)}>{params.value!.toString()}</Link>
        ) : (
          params.value!.toString()
        ),
      flex: 1,
      minWidth: 240
    },
    {
      field: 'tmf_document_id',
      headerName: 'Document Number',
      flex: 1,
      minWidth: 220
    },
    {
      field: 'tmf_doc_status',
      headerName: 'Status',
      flex: 1,
      minWidth: 150
    },
    {
      field: 'tmf_doc_version_number',
      headerName: 'Document Version',
      flex: 1,
      valueFormatter: (params: GridValueFormatterParams) => {
        const valueFormatted = String(parseFloat(params.value as string).toFixed(1));
        return `${valueFormatted}`;
      }
    },
    {
      field: 'updated_on',
      headerName: 'Last Modified',
      flex: 1,
      valueFormatter: (params: GridValueFormatterParams) => {
        return preferedDateFormat(params.value);
      }
    }
  ];
  const today = new Date();

  useEffect(() => {
    if (page * pageSize > rowCount - 1) {
      setPage(0);
      searchData(selectedStudy, selectedCountry, selectedSite, 0, pageSize);
    } else searchData(selectedStudy, selectedCountry, selectedSite, page * pageSize, pageSize);
    if (dataGridComponent || props.onClicked) {
      props.routeInfo('');
      setDataGridComponent(true);
    } else {
      props.routeInfo('recent_doc');
    }
  }, [selectedStudy, selectedCountry, selectedSite, page, pageSize, dataGridComponent, props.onClicked]);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      props.routeInfo(null);
    };
  }, []);

  const fetchUpdatedData = async () => {
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: documentDetail.data[0].tmf_document_name
    };
    const getUpdatedDocumentData: any = await docService.getMasterDocumentAllSession(
      documentDetail.data[0].tmf_doc_level,
      selectedStudy,
      selectedCountry,
      selectedSite,
      params,
      false
    );
    const selectedDocumentData = getUpdatedDocumentData.data.filter((el: DocumentRespType) => {
      if (el.file_master.id === documentToDisplay?.fileId) {
        return el;
      }
    })[0];

    const updData = { ...selectedDocumentData.file_master, ...selectedDocumentData.document_data };
    setUpdatedPropsForDoc(updData);
    setDocumentToDisplay(updData);
  };

  const searchData = async (study: string, country: string, site: string, from: number, size: number) => {
    setIsLoading(true);
    if (study !== '--' && study !== undefined && study !== '' && from !== undefined && size !== undefined) {
      const params = {
        module_section_related: 'DocumentDetails',
        parent_entity_related: '--'
      };
      const response = await docService.getRecentDocumentApi(study, country, site, TmfLevel, false, params, from, size);
      if (response.data) {
        setDocumentData(response.data);
        const documentDataTotal = response.data?.selected_data?.map((el: any) => {
          el.file_master.fmId = el.file_master.id; //  to preserve the document id of file_master temporarily
          el.document_data.fileId = el.file_master.id;
          el.file_master.docFormat = el.file_master.tmf_doc_type; //  to preserve the doc format of file_master because we have two fields with tmf_doc_type in both file_master and Documemt_data which is overwritten.
          el.document_data.hashed_uri_key = el.hashed_uri_key;
          el.document_data.need_to_sent_to_isf = el.need_to_sent_to_isf;
          return el;
        });
        const comData = documentDataTotal.map(
          (respo: { document_data: any; file_master: any }) => [{ ...respo.file_master, ...respo.document_data }][0]
        );
        setResult(comData);
        setRowCount(response.data.record_count);
        setIsLoading(false);
      } else {
        setResult([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } else {
      setResult([]);
      setRowCount(0);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (updatedPropsForDoc) {
      setDocumentToDisplay({ ...documentToDisplay, ...updatedPropsForDoc });
    }
  }, [updatedPropsForDoc]);

  const getDocument = async () => {
    if (
      documentKey !== null &&
      documentKey?.document_id !== null &&
      documentKey?.document_id !== '' &&
      documentKey?.document_id !== undefined
    ) {
      try {
        setLoading(true);
        const result = await docService.getDocument(documentKey);
        if (result.error === 403) {
          setDeleteDocumentCheck(false);
          setLoading(false);
        } else {
          if (!result.data && documentKey.document_id && documentKey.document_id !== 'cleared') {
            setDeleteDocumentCheck(true);
            setLoading(false);
          } else {
            setLoading(false);
            result.data.file_master.fmId = result.data.file_master.id;
            result.data.document_data.fileId = result.data.file_master.id;
            result.data.file_master.docFormat = result.data.file_master.tmf_doc_type;
            result.data.document_data.hashed_uri_key = result.data.hashed_uri_key;
            const comData = { ...result.data?.file_master, ...result.data?.document_data };
            gridFunc(comData);
          }
        }
      } catch (e) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (
      documentKey !== null &&
      documentKey?.document_id !== null &&
      documentKey?.document_id !== '' &&
      documentKey?.document_id !== undefined
    ) {
      setDataGridComponent(true);
      setDocumentDetail(dispatch, []);
      getDocument();
    }
  }, [documentKey]);

  const { isLoading: getStudyLoad } = useGetStudiesQuery();

  if (loading)
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress />
        </Backdrop>
      </>
    );

  return (
    <div>
      {dataGridComponent ? (
        deleteDocumentCheck ? (
          <DeleteDocument />
        ) : (
          <div>
            <SearchHierarchy searchData={searchData} />
            {isDataAvailable != null && isDataAvailable === false && !getStudyLoad ? (
              <div className="no-data-class">
                <h3>No Data access available!</h3>
              </div>
            ) : (
              <>
                <Grid container className="recent-documents">
                  <Grid md={8}>
                    <h5>Documents</h5>
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid xs={12} sm={12} md={12}>
                    <div className="mydata-grid-row" style={{ height: '74vh', minHeight: 300, width: '100%' }}>
                      <DataGridPro
                        rows={result}
                        columns={columns}
                        rowCount={rowCount}
                        page={page}
                        loading={isLoading}
                        onPageChange={newPage => setPage(newPage)}
                        pageSize={pageSize}
                        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                        rowsPerPageOptions={[5, 10, 20]}
                        pagination
                        paginationMode="server"
                        initialState={{
                          sorting: {
                            sortModel: [{ field: 'updated_on', sort: 'desc' }]
                          }
                        }}
                        components={{ Pagination: CustomPagination }}
                        getRowHeight={() => 'auto'}
                        sx={{
                          '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                          '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                          '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '20px' },
                          '& .MuiDataGrid-cell': { wordBreak: 'break-all' }
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
          </div>
        )
      ) : (
        <div>
          <DocumentViewerComponent
            documentDetails={documentToDisplay}
            fetchUpdatedData={fetchUpdatedData}
            props={props}
            setDataGridComponent={setDataGridComponent}
            setOpenVersion={setOpenVersion}
            setEditedFmID={setEditedFmID}
          />
        </div>
      )}
    </div>
  );
};

export default RecentDocuments;
